"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotPrinter = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotPrinter = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#Spot=on,_Size=40_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M4.857 17.78c1.738-5.087 7.916-9.787 13.373-11.594 5.482-1.818 11.979-.362 16.283 3.888 4.304 4.25 6.402 10.611 5.107 15.97-1.26 5.374-5.757 8.608-9.715 10.583-3.983 1.985-7.428 1.992-11.538.997-4.123-.96-8.301-2.541-10.448-6.26-2.147-3.72-4.824-8.487-3.062-13.584Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    d: "M31.25 17.025a1.1 1.1 0 0 0 0 2.2h.017a1.1 1.1 0 0 0 0-2.2h-.017Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M8.334 3.9a1.1 1.1 0 0 0-1.1 1.1v7.233h-.566c-1.216 0-2.355.538-3.175 1.45-.817.907-1.259 2.115-1.259 3.354v9.26c0 1.238.442 2.446 1.26 3.354.82.911 1.958 1.449 3.174 1.449H8.9V35a1.1 1.1 0 0 0 1.1 1.1h20a1.1 1.1 0 0 0 1.1-1.1v-3.9h2.233c1.216 0 2.355-.538 3.175-1.449.817-.908 1.259-2.116 1.259-3.355v-9.26c0-1.238-.442-2.446-1.259-3.354-.82-.911-1.96-1.449-3.175-1.449h-.566V5a1.1 1.1 0 0 0-1.1-1.1H8.334ZM6.668 14.433h26.666c.553 0 1.11.243 1.54.72.433.482.694 1.158.694 1.884v9.26c0 .725-.26 1.4-.694 1.882-.43.478-.987.72-1.54.72h-2.233v-5.566a1.1 1.1 0 0 0-1.1-1.1h-20a1.1 1.1 0 0 0-1.1 1.1V28.9H6.668c-.553 0-1.11-.243-1.54-.72-.433-.482-.694-1.158-.694-1.884v-9.26c0-.725.26-1.4.694-1.882.43-.478.987-.72 1.54-.72Zm2.766-2.2h21.134V6.1H9.434v6.133Zm19.467 12.2V33.9h-17.8v-9.467h17.8Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "Spot=on,_Size=40_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotPrinter = SpotPrinter;
SpotPrinter.displayName = "SpotPrinter";